import { isLaunchedAsIOSApp } from './ios'

export function openExternalUrl(externalUrl: string, target?: string) {
	window.open(externalUrl, isLaunchedAsIOSApp() ? '_blank' : target, 'noopener,noreferrer')
}
